export const COOKIE_NAME = 'HIDE_PHI';
export const EVENT_NAME = 'hide-phi';